function zeroPadInt(n = 0, padding = 2) {
  return n.toString().padStart(padding, '0');
}

export interface PartialDate {
  month: number;
  year: number;
  day: number;
}

export const partialDateToString = (partialDate: PartialDate) => {
  try {
    const { month, day = 1, year } = partialDate;

    const zeroPrefixedMonth = zeroPadInt(month);
    const zeroPrefixedDay = zeroPadInt(day);

    return `${zeroPrefixedMonth}/${zeroPrefixedDay}/${year}`;
  } catch (err) {
    return '';
  }
};

export type MaybePartialDate = { isValid: boolean; dateObject: PartialDate };

/**
 * Convert a given string in 'MM/DD/YYYY' format to a `PartialDate`
 * If it can't be converted, the returned object will reflect that
 * @param dateString The string to be converted into a `PartialDate`
 */
export const partialDateFromString = (dateString = ''): MaybePartialDate => {
  const dateParts = dateString.split('/').map((part) => parseInt(part, 10));
  const partsAreMissing =
    // Only accepts dates with a day, month, and year
    dateParts.length != 3 ||
    // If a part wasn't parseable by `parseInt` then consider it "missing"
    dateParts.filter(isNaN).length > 0;

  const [month, day, year] = dateParts;

  if (partsAreMissing) {
    return {
      isValid: false,
      dateObject: { month, day, year },
    };
  }

  return {
    dateObject: {
      month,
      day,
      year,
    },
    isValid: true,
  };
};

// Do you think this code is dumb? Let Zelda know what you'd do instead. If you'd just like to know more
// about why it's written this way, also let Zelda know.
/**
 * For a given `PartialDate`, check if it is within the range of start and end dates
 * @param date The `PartialDate` to test
 * @param start the starting date of the range to test
 * @param end the ending date of the range to test
 */
export const isInPartialDateRange = (date: PartialDate, start: PartialDate, end: PartialDate) => {
  if ([date, start, end].some((el) => el == null)) {
    console.error('Bad input to isInPartialDateRange:', [date, start, end]);

    throw new Error('Must pass a valid PartialDate for all 3 arguments of isInPartialDateRange');
  }

  const dateAsWeirdNumber = date.year + date.month * 0.01 + (date.day || 0) * 0.0001;
  const startAsWeirdNumber = start.year + start.month * 0.01 + (start.day || 0) * 0.0001;
  const endAsWeirdNumber = end.year + end.month * 0.01 + (end.day || 0) * 0.0001;

  return dateAsWeirdNumber >= startAsWeirdNumber && dateAsWeirdNumber <= endAsWeirdNumber;
};
